function SelectValidator(elemSelector) {
    var elem = (elemSelector instanceof HTMLSelectElement)
        ? elemSelector
        : document.querySelector(elemSelector);

    if (elem == null) {
        return;
    }

    var requiredMsg = (elem.dataset && elem.dataset.msgRequired) ? elem.dataset.msgRequired : 'Please select a value';
    var isRequired = (elem.dataset && elem.dataset.ruleRequired && elem.dataset.ruleRequired === 'true');

    function showError(errorMsg) {
        var div = elem.parentElement.parentElement;
        var span = div.querySelector('span.k-dropdownlist');
        var label = div.querySelector('label');

        span
            && span.classList
            && span.classList.add('error');

        label
            && $(label).remove();

        $(div).append('<label class="error">' + errorMsg + '</label>');
    }

    function clearError() {
        var div = elem.parentElement.parentElement;
        var span = div.querySelector('span.k-dropdownlist');

        span
            && span.classList
            && span.classList.remove('error');

        $(div).find('label').remove();
    }

    function isRequiredValid() {
        return (elem.value !== '');
    }

    if (isRequired) {
        $(elem).data("kendoDropDownList") &&
            $(elem).data("kendoDropDownList").bind("change", function() {
                if ($(elem).data("kendoDropDownList").value() !== '') {
                    clearError();
                }
            });
    }

    var m = {
        isValid: function() {
            var isValid = true;

            if (isRequired && !isRequiredValid()) {
                showError(requiredMsg);
                return false;
            }

            clearError();
            return isValid;
        },
        elemSelector: elemSelector,
    };

    return m;
};

